module.exports = __webpack_public_path__ + "img/e0fd9e4.png";